module.exports = "/_next/static/images/cb591a18acab8e203ad43be69d2a60e7-animated-logo.gif.webp";